import { MainLayout } from '@components/layouts/main.layout';
import { ProductsGridTile } from '@components/pages/product/components/products-grid-tile.component';
import { HelmetWrapper } from '@components/shared/helmet.component';
import { PageviewTracker } from '@components/shared/pageview-tracker.component';
import { ProductsSankeyTile } from '@components/shared/products-sankey.component';
import { useGetProducts } from '@queries/product.query';
import { useGetCurrentUser } from '@queries/users.query';
import { routes } from '@routes';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const ProductsPage: React.FC = () => {
  const { data: user, isPending: isUserPending } = useGetCurrentUser();
  const { data: products, isPending: isProductsPending } = useGetProducts();

  const navigate = useNavigate();
  const company = user?.companies?.[0];

  useEffect(() => {
    if (!isUserPending && !company) {
      navigate(routes.home.path);
    }
  }, [isUserPending, company, navigate]);

  const isLoading = isUserPending || isProductsPending;
  const hasProducts = (products?.length ?? 0) > 0;

  return (
    <PageviewTracker>
      <HelmetWrapper title="Products" />
      <MainLayout
        aside={<ProductsGridTile />}
        asideClassName={
          hasProducts ? 'order-1 @min-[56rem]/main:order-2' : 'order-1 w-full @min-[56rem]/main:max-w-[70%]'
        }
        columnsStartAtContainer="56rem"
        contentClassName={hasProducts ? 'order-2 @min-[56rem]/main:order-1' : 'hidden'}
      >
        {!isLoading && hasProducts && <ProductsSankeyTile sankeyProps={{ maxHeight: 600 }} />}
      </MainLayout>
    </PageviewTracker>
  );
};
